export const familles = [
    { code: "#889088", name: "grey", title: "Gris" },
    { code: "#804818", name: "brown", title: "Brun" },
    { code: "#000", name: "black", title: "Noir" },
    { code: "#fff", name: "white", title: "Blanc" },
    { code: "#f4f3d7", name: "beige", title: "Beige" },
    { code: "#3048c0", name: "blue", title: "Bleu" },
    { code: "#286030", name: "green", title: "Vert" },
    { code: "#d02830", name: "red", title: "Rouge" },
    { code: "#e848a8", name: "pink", title: "Rose" },
    { code: "#e0e028", name: "yellow", title: "Jaune" },
    { code: "#e07020", name: "orange", title: "Orange" },
    { code: "violet", name: "purple", title: "Violet" },
    { code: "multicolor", name: "multicolor", title: "Multicolore" }
]